import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { EmailResponse } from '@core/interfaces/email.interface';

@Injectable({ providedIn: 'root' })
export class EmailService {
  private readonly http = inject(HttpClient);

  public getEmail(): Observable<string> {
    const headers = new HttpHeaders({ caller: 'MABANQUE' });
    return this.http
      .get<EmailResponse>('/rgg/persons/email-reliability/v1/customers/me/email', { headers })
      .pipe(
        map(
          ({ addressFirstPart, addressSecondPart }) => `${addressFirstPart}@${addressSecondPart}`,
        ),
      );
  }
}
